import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'arrayObject',
})
export class ArrayObjectPipe implements PipeTransform {
	transform(value: unknown, elementIndex: number, propertyName: string): unknown {
		if (Array.isArray(value)) {
			if (elementIndex) {
				return value[elementIndex][propertyName];
			} else {
				return value[0][propertyName];
			}
		}
		return value;
	}
}
